// PDP Page
$(document).ready(() => {

  $('.product-specification details').attr('open','');
  
  // PDP Zoom Effect
  const mediaQuery = window.matchMedia("(min-width: 750px)");

  if (mediaQuery.matches) {
    var driftImgs = document.querySelectorAll(".product__media img[data-zoom]");
    driftImgs.forEach((img) => {
      new Drift(img, {
        paneContainer: img.nextElementSibling,
        inlinePane: false,
        zoomFactor: 2,
      });

      img.addEventListener("mouseover", function () {
        img.nextElementSibling.setAttribute(
          "style",
           "display: block !important; left: 103% !important; height: 50rem !important; width: 50rem !important;"
        );
      });

      img.addEventListener("mouseout", function () {
        img.nextElementSibling.setAttribute(
          "style",
          "display: none !important;"
        );
      });
    });
  }

  // Variant Thumbnail Slider
  let thumb_img_arr = document.querySelectorAll(".thumbnail__images");
  if (curr_variant.title != "Default Title") {
    title_arr = curr_variant.title.replace(/ +/g, "").toLowerCase().split("/");
    thumb_img_arr.forEach((el, index) => {
      let alt = el.getAttribute("alt").replace(/ +/g, "").toLowerCase();

      let cnt = 0;
      title_arr.forEach((title_el) => {
        if (alt.includes(title_el)) {
          cnt++;
        }
      });

      if (cnt == title_arr.length) {
        el.closest(".thumbnail-list__item").classList.remove("hidden");
      } else {
        el.closest(".thumbnail-list__item").classList.add("hidden");
      }
    });
  }

  // For Mobile
  let mobile_query = window.matchMedia("(max-width: 749px)");
  if (mobile_query.matches && curr_variant.title != "Default Title") {
    let mobile_thumb_img_arr = document.querySelectorAll(
      ".slider--mobile .product__media-item"
    );

    let slick_dots_cnt = 0;
    mobile_thumb_img_arr.forEach((mobile_img, index) => {
      let alt = mobile_img
        .querySelector(".product__media img")
        .getAttribute("alt")
        .replace(/ +/g, "")
        .toLowerCase();

      let cnt = 0;
      title_arr.forEach((title_el) => {
        if (alt.includes(title_el)) {
          cnt++;
        }
      });
      if (cnt == title_arr.length) {
        mobile_img.classList.remove("hidden");
        slick_dots_cnt++;
      } else {
        mobile_img.classList.add("hidden");
      }
    });

    // Mobile Slider Dots
    document
      .querySelectorAll(
        ".product-slider-buttons .slick-dots .product-slider-dot"
      )
      .forEach((dots, index) => {
        if (index >= slick_dots_cnt) {
          $(`[data-slideno='${index + 1}']`).addClass("hidden");
        } else {
          $(`[data-slideno='${index + 1}']`).removeClass("hidden");
        }
      });
  }
  $(".slick-dots").attr("style", "display:flex!important");
 
});

